import React from "react";
import type {VoidFunctionComponent} from "react";
import ExternalLink from "../../../components/common/ExternalLink";
import Form from "../../../components/common/Form";
import {useAppSelector} from "../../../redux/hooks";
import {myProfileStore} from "../../../redux/my-profile/myProfileStore";
import {baseUrlForWebsite} from "../../../client/PlaygroundSettings";
import TextBox from "../../../components/common/textBox/TextBox";

export const AccountInfoSection: VoidFunctionComponent = () => {
  const isReady = useAppSelector(myProfileStore.getIsMyProfileReady);
  const firstName = useAppSelector(myProfileStore.getMyProfileFirstName);
  const lastName = useAppSelector(myProfileStore.getMyProfileLastName);
  const email = useAppSelector(myProfileStore.getMyProfileEmail);
  const username = useAppSelector(myProfileStore.getMyProfileUsername);

  if (!isReady){
    return <div>loading...</div>;
  }

  return (
    <Form additionalClassName="account-info">
      <>
        { (firstName ?? "").length > 0
          ? <TextBox disabled={true} label="First name" value={firstName ?? ``} onChange={()=>{}}/>
          : null
        }
      </>
      <>
        { (lastName ?? "").length > 0
          ? <TextBox disabled={true} label="Last name" value={lastName ?? ``} onChange={()=>{}}/>
          : null
        }
      </>
      <>
        { ((username ?? "") !== (email ?? ""))
          ? <TextBox disabled={true} label="Username" value={username ?? ``} onChange={()=>{}}/>
          : null
        }
      </>
      <TextBox disabled={true} label="Email address" value={email ?? ``} onChange={()=>{}}/>
      <ExternalLink additionalClassName={'changePasswordLink'} url={`${baseUrlForWebsite}/my-account/change-password`} title={`Change Password on Playground Site`}/>
    </Form>
  );
}
